"use client";

import React from "react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Separator } from "@/components/ui/separator";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function FindYourNextChapter() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="242629" id="find-your-next-chapter" className="bg-background text-foreground relative min-h-screen flex items-center justify-center overflow-hidden">
      {}
      <div className="absolute inset-0 z-0">
        <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1686159/img/urban_cityscape_luxury_apartments.png" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1686159/img/urban_cityscape_luxury_apartments.png-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1686159/img/urban_cityscape_luxury_apartments.png-wvc-sizes" alt="Modern Urban Cityscape" className="w-full h-full object-cover" loading="lazy" />
        <div className="absolute inset-0 bg-white/40 bg-gradient-to-b from-white/60 to-transparent"></div>
      </div>

      {}
      <div ref={ref} className={`relative z-10 container mx-auto px-4 flex flex-col items-center text-center transition-all duration-1000 transform ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10"}`}>
        <h1 className="font-default text-5xl md:text-7xl lg:text-[4rem] leading-tight text-primary mb-8 max-w-5xl font-bold tracking-tighter">
          Find Your Next Chapter
        </h1>

        <Separator className="w-24 h-[1px] bg-primary mx-auto mb-8" />

        <p className="text-lg md:text-xl text-foreground/80 max-w-2xl mx-auto mb-12 font-default font-medium tracking-normal">
          Discover curated luxury apartments in the heart of the city's most vibrant neighborhoods.
        </p>

        <div className="flex flex-col sm:flex-row gap-6 items-center justify-center">
          <Link to="/ResidencesPage">
            <Button size="lg" className="bg-primary text-white rounded-md px-10 py-7 text-sm md:text-base uppercase tracking-widest transition-colors shadow-lg hover:bg-primary">
              Find Home
            </Button>
          </Link>
          <Link to="/ScheduleAVisitPage">
            <Button size="lg" className="bg-primary text-white rounded-md px-10 py-7 text-sm md:text-base uppercase tracking-widest transition-colors shadow-lg hover:bg-primary">
              Book a Tour
            </Button>
          </Link>
        </div>
      </div>

      {}
      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 flex flex-col items-center gap-3 z-10 animate-pulse">
        <span className="text-primary/60 text-[10px] uppercase tracking-[0.3em] font-default">Explore</span>
        <div className="w-[1px] h-16 bg-gradient-to-b from-primary/60 to-transparent"></div>
      </div>
    </section>;
}